import propTypes from 'prop-types';
const AlternativeModalButtonsContainer = ({ children }) => {
  return (
    <>
      <style>{`
          @media (max-width: 767px) {
            .button-container > .btn {
              width: 100%;
            }
            .button-container > :nth-child(1) {
              order: 1;
            }
            .button-container > :nth-child(2) {
              order: 2;
            }
          }
        `}</style>

      <div
        className="d-flex flex-column-reverse flex-md-row justify-content-end button-container mt-3"
        style={{ gap: '1rem', width: '100%' }}
      >
        {children}
      </div>
    </>
  );
};

AlternativeModalButtonsContainer.propTypes = {
  children: propTypes.node.isRequired
};

export default AlternativeModalButtonsContainer;
